var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-footer',{staticClass:"bg-grey-8 text-white",attrs:{"bordered":""}})}
var staticRenderFns = []

export { render, staticRenderFns }